import { Module } from 'vuex';
import { IRootState, IContractState } from '@types';

import { ContractModel } from '@model';

import Env from '@lib/Env';

import { ContractsApi } from '@/api';

const store: Module<IContractState, IRootState> = {
    state: {
        contract: <ContractModel>null,
        contracts: <ContractModel[]>[],
    },

    mutations: {
        setContract: (state, contract: ContractModel) => (state.contract = contract),
        setContracts: (state, records: ContractModel[]) => (state.contracts = records),
    },

    getters: {
        getContract: (state): ContractModel => state.contract,
        getContracts: (state): ContractModel[] => state.contracts,
    },

    actions: {
        async loadContract({ state }, id: number): Promise<ContractModel> {
            const { data } = await ContractsApi.load(id);
            state.contract = new ContractModel(data);
            return state.contract;
        },

        async loadContracts({ state, getters }): Promise<ContractModel[]> {
            const { data } = await getters.getActor.loadContracts();
            state.contracts = data.contracts.map((item: any) => new ContractModel(item));
            return state.contracts;
        },
    },
};

export default store;
